export class product_detail_marketing_information_media_asset {
  public name: string = "";
  public width: number = 0;
  public height: number = 0;
  public asset_url: string = "";
}
